import _ from 'lodash';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export enum NavigationStates {
  TOOL = 'tool',
  PROJECTS = 'projects',
  LINKEDIN_ACCOUNT_MANAGEMENT = 'linkedinAccountManagement',
  BLACKLIST = 'blacklist',
  STATISTICS = 'statistics',
  INBOX = 'inbox',
  PRODUCT_OVERVIEW = 'productOverview',
  SHOPS = 'shops',
  TAG_MANAGEMENT = 'tagManagement',
  INTEGRATIONS = 'integrations', // Existing Integrations tab
  WEBMETICS_OVERVIEW = 'webmeticsOverview', // New entry for Webmetics Overview
  TASK_MANAGER = 'taskManager',
  POSTING_CREATION = 'postingCreation', // New entry for Posting Creation
  LEAD_LIST_RESEARCH = 'leadListResearch', // New entry for Lead List Research
  PIPELINE = 'pipeline',
}

interface AppBarNavigationStore {
  activeTab: NavigationStates;
  setActiveTab: (newNavigation: NavigationStates, persist?: boolean) => void;
}

const storedActiveTab = localStorage.getItem('active-tab') as NavigationStates;

const useAppBarNavigationStore = createWithEqualityFn<AppBarNavigationStore>(
  (set) => ({
    activeTab: storedActiveTab ?? NavigationStates.TOOL,
    setActiveTab(newNavigation: NavigationStates, persist = true) {
      set(() => ({ activeTab: newNavigation }));
      if (!persist) {
        return;
      }
      if (!_.isNil(newNavigation)) {
        localStorage.setItem('active-tab', newNavigation);
      } else {
        localStorage.removeItem('active-tab');
      }
    },
  }),
  shallow
);

export default useAppBarNavigationStore;
